/**
 * Auth Getters - Vuex Store Getters (TypeScript)
 *
 * Provides computed access to auth state
 */

import type { AuthState } from './mutations';

export default {
  userId(state: AuthState): string | null {
    return state.userId;
  },
  token(state: AuthState): string | null {
    return state.token;
  },
  isAuthenticated(state: AuthState): boolean {
    return !!state.token;
  },
  userName(state: AuthState): string | null {
    return state.name;
  },
  userLastName(state: AuthState): string | null {
    return state.lastName;
  },
  userEmail(state: AuthState): string | null {
    return state.email;
  },
  userRole(state: AuthState): string | null {
    return state.role;
  },
};


